module.exports = __webpack_public_path__ + "Iconawesome-user-circle.png";